// extracted by mini-css-extract-plugin
export default {"logout":"style_logout__PeZlK","adminTabs":"style_adminTabs__L7bf3","active":"style_active__FOtwM"};